import classes from "./Terms.module.css";

import { useEffect,useContext,useState } from "react";
import cookies from "js-cookie";
import LanguageContext from "../../store/language-context";
import { useTranslation } from "react-i18next";

function Terms() {

  const controller = new AbortController();
  const { signal } = controller;
  const { t } = useTranslation()
  var currentLanguageCode = cookies.get("i18next") || "el";
  const languageCtx = useContext(LanguageContext);
  const [language, setLanguage] = useState();

 function TermsEl() {
 
  return(
  
    <div><div className={classes.pHead}><div className={classes.pTitle}><h1>Όροι και Προϋποθέσεις Χρήσης</h1></div></div><div className={classes.pContent}><h2>
    Όροι και Προϋποθέσεις Χρήσης
</h2>
<h3>
    1. Εισαγωγή
</h3>
<p>
    Καλώς ήρθατε στον επίσημο ιστότοπο του Δήμου Αποκορώνου (εφεξής ο "Ιστότοπος"). Με την πρόσβαση και τη χρήση αυτού του Ιστότοπου, αποδέχεστε πλήρως και ανεπιφύλακτα τους παρόντες Όρους και Προϋποθέσεις Χρήσης.
</p>
<h3>
    2. Γενικοί Όροι
</h3>
<p>
    2.1. Ο Δήμος Αποκορώνου διατηρεί το δικαίωμα να τροποποιεί τους παρόντες όρους και προϋποθέσεις ανά πάσα στιγμή, χωρίς προηγούμενη ειδοποίηση. Οι αλλαγές θα τίθενται σε ισχύ από τη δημοσίευσή τους στον Ιστότοπο.
</p>
<p>
    2.2. Συνιστάται στους χρήστες να ελέγχουν τακτικά τους Όρους και Προϋποθέσεις για τυχόν αλλαγές.
</p>
<h3>
    3. Πνευματικά Δικαιώματα
</h3>
<p>
    3.1. Όλο το περιεχόμενο του Ιστότοπου (κείμενα, εικόνες, γραφικά, λογότυπα, βίντεο, κλπ.) αποτελεί πνευματική ιδιοκτησία του Δήμου Αποκορώνου ή τρίτων μερών που έχουν παράσχει σχετικές άδειες χρήσης.
</p>
<p>
    3.2. Απαγορεύεται η αναπαραγωγή, διανομή, τροποποίηση, ή άλλη χρήση του περιεχομένου του Ιστότοπου χωρίς την προηγούμενη γραπτή άδεια του Δήμου Αποκορώνου.
</p>
<h3>
    4. Προσωπικά Δεδομένα
</h3>
<p>
    4.1. Ο Δήμος Αποκορώνου δεσμεύεται να προστατεύει την ιδιωτικότητα των χρηστών του Ιστότοπου. Τα προσωπικά δεδομένα που συλλέγονται μέσω του Ιστότοπου χρησιμοποιούνται αποκλειστικά για τους σκοπούς που έχουν δηλωθεί.
</p>
<p>
    4.2. Για περισσότερες πληροφορίες σχετικά με την επεξεργασία των προσωπικών δεδομένων, παρακαλούμε διαβάστε την Πολιτική Προστασίας Προσωπικών Δεδομένων.
</p>
<h3>
    5. Περιορισμός Ευθύνης
</h3>
<p>
    5.1. Ο Δήμος Αποκορώνου καταβάλλει κάθε δυνατή προσπάθεια ώστε το περιεχόμενο του Ιστότοπου να είναι ακριβές και ενημερωμένο. Ωστόσο, δεν εγγυάται την πληρότητα, ακρίβεια ή επικαιρότητα του περιεχομένου.
</p>
<p>
    5.2. Ο Δήμος Αποκορώνου δεν φέρει ευθύνη για τυχόν άμεσες ή έμμεσες ζημίες που προκύπτουν από τη χρήση του Ιστότοπου ή από την αδυναμία πρόσβασης σε αυτόν.
</p>
<h3>
    6. Σύνδεσμοι σε Τρίτους Ιστότοπους
</h3>
<p>
    6.1. Ο Ιστότοπος μπορεί να περιέχει συνδέσμους προς άλλους ιστότοπους που διαχειρίζονται τρίτοι. Ο Δήμος Αποκορώνου δεν ελέγχει το περιεχόμενο αυτών των ιστότοπων και δεν φέρει ευθύνη για την ασφάλεια ή τη διαθεσιμότητά τους.
</p>
<p>
    6.2. Η συμπερίληψη συνδέσμων σε τρίτους ιστότοπους δεν αποτελεί ένδειξη έγκρισης ή υποστήριξης αυτών από τον Δήμο Αποκορώνου.
</p>
<h3>
    7. Εφαρμοστέο Δίκαιο και Δικαιοδοσία
</h3>
<p>
    7.1. Οι παρόντες Όροι και Προϋποθέσεις διέπονται από το ελληνικό δίκαιο.
</p>
<p>
    7.2. Για οποιαδήποτε διαφορά που προκύπτει από τη χρήση του Ιστότοπου, αρμόδια είναι τα δικαστήρια των Χανίων.
</p>
<h3>
    8. Επικοινωνία
</h3>
<p>
    Για οποιαδήποτε ερώτηση ή απορία σχετικά με τους παρόντες Όρους και Προϋποθέσεις, μπορείτε να επικοινωνήσετε με τον Δήμο Αποκορώνου μέσω email στη διεύθυνση: <a rel="noreferrer">info@apokoronas.gr</a>.
</p></div>
  </div>
  
  )};
  
  function TermsEn() {
   
    return(
    
      <div><div className={classes.pHead}><div className={classes.pTitle}><h1>Terms and Conditions of Use</h1></div></div><div className={classes.pContent}><p>
      Terms and Conditions of Use
  </p>
  <p>
      1 Introduction
  </p>
  <p>
      Welcome to the official website of the Municipality of Apokoronou (hereinafter the "Website"). By accessing and using this Website, you fully and unconditionally accept these Terms and Conditions of Use.
  </p>
  <p>
      2. General Terms
  </p>
  <p>
      2.1. The Municipality of Apokoronou reserves the right to modify these terms and conditions at any time, without prior notice. Changes will be effective upon their posting on the Website.
  </p>
  <p>
      2.2. Users are advised to regularly check the Terms and Conditions for any changes.
  </p>
  <p>
      3. Copyright
  </p>
  <p>
      3.1. All the content of the Website (texts, images, graphics, logos, videos, etc.) is the intellectual property of the Municipality of Apokoronos or third parties that have provided relevant licenses.
  </p>
  <p>
      3.2. The reproduction, distribution, modification, or other use of the content of the Website is prohibited without the prior written permission of the Municipality of Apokoronos.
  </p>
  <p>
      4. Personal Data
  </p>
  <p>
      4.1. The Municipality of Apokoronou is committed to protecting the privacy of the Website users. The personal data collected through the Website is used exclusively for the stated purposes.
  </p>
  <p>
      4.2. For more information about the processing of personal data, please read the Privacy Policy.
  </p>
  <p>
      5. Limitation of Liability
  </p>
  <p>
      5.1. The Municipality of Apokoronou makes every effort to ensure that the content of the Website is accurate and up-to-date. However, it does not guarantee the completeness, accuracy or timeliness of the content.
  </p>
  <p>
      5.2. The Municipality of Apokoronou is not responsible for any direct or indirect damages resulting from the use of the Website or from the inability to access it.
  </p>
  <p>
      6. Links to Third Party Sites
  </p>
  <p>
      6.1. The Website may contain links to other websites operated by third parties. The Municipality of Apokoronou does not control the content of these websites and is not responsible for their security or availability.
  </p>
  <p>
      6.2. The inclusion of links to third party websites is not an indication of approval or endorsement by the Municipality of Apokoronou.
  </p>
  <p>
      7. Applicable Law and Jurisdiction
  </p>
  <p>
      7.1. These Terms and Conditions are governed by Greek law.
  </p>
  <p>
      7.2. For any dispute arising from the use of the Website, the courts of Chania are competent.
  </p>
  <p>
      8. Communication
  </p>
  <p>
      For any questions or concerns regarding these Terms and Conditions, you can contact the Municipality of Apokoronos via email at info@apokoronas.gr.
  </p></div>
    </div>
    
    )};

    function TermsFr() {
   
      return(
      
        <div><div className={classes.pHead}><div className={classes.pTitle}><h1>Termes et conditions d'utilisation</h1></div></div><div className={classes.pContent}><p>
        Termes et conditions d'utilisation
    </p>
    <p>
        1. Introduction
    </p>
    <p>
        Bienvenue sur le site officiel de la Commune d'Apokoronou (ci-après le « Site Internet »). En accédant et en utilisant ce site Web, vous acceptez pleinement et inconditionnellement les présentes conditions générales d'utilisation.
    </p>
    <p>
        2. Conditions générales
    </p>
    <p>
        2.1. La Commune d'Apokoronou se réserve le droit de modifier les présentes conditions générales à tout moment, sans préavis. Les modifications entreront en vigueur dès leur publication sur le site Web.
    </p>
    <p>
        2.2. Il est conseillé aux utilisateurs de vérifier régulièrement les conditions générales pour connaître toute modification.
    </p>
    <p>
        3. Droits d'auteur
    </p>
    <p>
        3.1. Tout le contenu du site Web (textes, images, graphiques, logos, vidéos, etc.) est la propriété intellectuelle de la municipalité d'Apokoronos ou de tiers qui ont fourni les licences correspondantes.
    </p>
    <p>
        3.2. La reproduction, la distribution, la modification ou toute autre utilisation du contenu du site Web est interdite sans l'autorisation écrite préalable de la municipalité d'Apokoronos.
    </p>
    <p>
        4. Données personnelles
    </p>
    <p>
        4.1. La Commune d'Apokoronou s'engage à protéger la vie privée des utilisateurs du Site Internet. Les données personnelles collectées via le site Web sont utilisées exclusivement aux fins indiquées.
    </p>
    <p>
        4.2. Pour plus d'informations sur le traitement des données personnelles, veuillez lire la politique de confidentialité.
    </p>
    <p>
        5. Limitation de responsabilité
    </p>
    <p>
        5.1. La Commune d'Apokoronou met tout en œuvre pour que le contenu du Site Internet soit exact et à jour. Toutefois, il ne garantit pas l’exhaustivité, l’exactitude ou l’actualité du contenu.
    </p>
    <p>
        5.2. La Commune d'Apokoronou n'est responsable d'aucun dommage direct ou indirect résultant de l'utilisation du Site Internet ou de l'impossibilité d'y accéder.
    </p>
    <p>
        6. Liens vers des sites tiers
    </p>
    <p>
        6.1. Le Site Web peut contenir des liens vers d'autres sites Web exploités par des tiers. La Commune d'Apokoronou ne contrôle pas le contenu de ces sites internet et n'est pas responsable de leur sécurité ou de leur disponibilité.
    </p>
    <p>
        6.2. L'inclusion de liens vers des sites Web tiers ne constitue pas une indication d'approbation ou d'approbation de la municipalité d'Apokoronou.
    </p>
    <p>
        7. Loi applicable et juridiction
    </p>
    <p>
        7.1. Les présentes conditions générales sont régies par le droit grec.
    </p>
    <p>
        7.2. Pour tout litige découlant de l'utilisation du Site Internet, les tribunaux de La Canée sont compétents.
    </p>
    <p>
        8.Communications
    </p>
    <p>
        Pour toute question ou préoccupation concernant ces termes et conditions, vous pouvez contacter la municipalité d'Apokoronas par e-mail à info@apokoronas.gr.
    </p></div>
      </div>
      
      )};
      function TermsDe() {
         return(
      
            <div><div className={classes.pHead}><div className={classes.pTitle}><h1> Allgemeine Geschäftsbedingungen</h1></div></div><div className={classes.pContent}><p>
            Allgemeine Geschäftsbedingungen
        </p>
        <p>
            1. Einleitung
        </p>
        <p>
            Willkommen auf der offiziellen Website der Gemeinde Apokoronou (im Folgenden die „Website“). Durch den Zugriff auf und die Nutzung dieser Website akzeptieren Sie diese Nutzungsbedingungen vollständig und bedingungslos.
        </p>
        <p>
            2. Allgemeine Geschäftsbedingungen
        </p>
        <p>
            2.1. Die Gemeinde Apokoronou behält sich das Recht vor, diese Allgemeinen Geschäftsbedingungen jederzeit und ohne vorherige Ankündigung zu ändern. Änderungen werden mit ihrer Veröffentlichung auf der Website wirksam.
        </p>
        <p>
            2.2. Benutzern wird empfohlen, die Allgemeinen Geschäftsbedingungen regelmäßig auf etwaige Änderungen zu überprüfen.
        </p>
        <p>
            3. Urheberrecht
        </p>
        <p>
            3.1. Der gesamte Inhalt der Website (Texte, Bilder, Grafiken, Logos, Videos usw.) ist geistiges Eigentum der Gemeinde Apokoronos oder Dritter, die entsprechende Lizenzen bereitgestellt haben.
        </p>
        <p>
            3.2. Die Vervielfältigung, Verbreitung, Änderung oder sonstige Nutzung des Inhalts der Website ist ohne vorherige schriftliche Genehmigung der Gemeinde Apokoronos untersagt.
        </p>
        <p>
            4. Persönliche Daten
        </p>
        <p>
            4.1. Die Gemeinde Apokoronou verpflichtet sich, die Privatsphäre der Website-Benutzer zu schützen. Die über die Website erhobenen personenbezogenen Daten werden ausschließlich für die angegebenen Zwecke verwendet.
        </p>
        <p>
            4.2. Weitere Informationen zur Verarbeitung personenbezogener Daten finden Sie in der Datenschutzerklärung.
        </p>
        <p>
            5. Haftungsbeschränkung
        </p>
        <p>
            5.1. Die Gemeinde Apokoronou unternimmt alle Anstrengungen, um sicherzustellen, dass der Inhalt der Website korrekt und aktuell ist. Eine Gewähr für die Vollständigkeit, Richtigkeit und Aktualität der Inhalte kann jedoch nicht übernommen werden.
        </p>
        <p>
            5.2. Die Gemeinde Apokoronou haftet nicht für direkte oder indirekte Schäden, die sich aus der Nutzung der Website oder aus der Unmöglichkeit des Zugriffs darauf ergeben.
        </p>
        <p>
            6. Links zu Websites Dritter
        </p>
        <p>
            6.1. Die Website kann Links zu anderen Websites enthalten, die von Dritten betrieben werden. Die Gemeinde Apokoronou hat keine Kontrolle über den Inhalt dieser Websites und ist nicht für deren Sicherheit oder Verfügbarkeit verantwortlich.
        </p>
        <p>
            6.2. Die Aufnahme von Links zu Websites Dritter stellt keinen Hinweis auf die Genehmigung oder Billigung durch die Gemeinde Apokoronou dar.
        </p>
        <p>
            7. Anwendbares Recht und Gerichtsstand
        </p>
        <p>
            7.1. Diese Allgemeinen Geschäftsbedingungen unterliegen griechischem Recht.
        </p>
        <p>
            7.2. Für alle Streitigkeiten, die sich aus der Nutzung der Website ergeben, sind die Gerichte von Chania zuständig.
        </p>
        <p>
            8. Kommunikation
        </p>
        <p>
            Bei Fragen oder Bedenken bezüglich dieser Allgemeinen Geschäftsbedingungen können Sie sich per E-Mail an die Gemeinde Apokoronos unter info@apokoronas.gr wenden.
        </p></div>
          </div>
          
          )};

  return (
    <div>
      {currentLanguageCode == 'el' &&
        <TermsEl />   
      }
      {currentLanguageCode == 'en' &&
        <TermsEn />   
      }
      {currentLanguageCode == 'fr' &&
        <TermsFr />   
      }
      {currentLanguageCode == 'de' &&
        <TermsDe />   
      }

    </div>
  );
}

export default Terms;
